function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6307 19.6786L12.8551 17.5112L0 10.1318V29.2256L34.2807 48.9043V29.8105L27.4247 25.8749L25.4559 24.7446L20.5684 21.939L16.6307 19.6786Z",
  fill: "#463C64"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6306 0L0.509277 9.25457L12.6003 16.1954L16.6306 18.5088V0Z",
  fill: "#00BEBE"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4558 23.5748V14.0278L33.7712 9.25457L17.6499 0V19.0938L20.7722 20.8862L25.4558 23.5748Z",
  fill: "#00BEBE"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.2815 28.6407V10.1318L26.4756 14.6126V24.1596L28.0369 25.0557L34.2815 28.6407Z",
  fill: "#463C64"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.6207 14.0273C61.5927 14.0273 62.9446 14.1217 64.083 14.8763C65.4111 15.7488 66.0515 17.258 66.0515 18.6964C66.0515 19.6158 65.814 21.031 64.5099 22.139C63.2529 23.2001 61.8065 23.3652 60.6441 23.3652H59.5534V29.7554H57.1343V14.0273H60.6207ZM59.5534 21.1486H60.6441C62.7311 21.1486 63.7273 20.1346 63.7273 18.6729C63.7273 17.8003 63.3715 16.244 60.6207 16.244H59.5534V21.1486V21.1486Z",
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M85.3107 14.0273V27.4916H89.9589V29.7554H82.8916V14.0273H85.3107Z",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M115.974 25.9586H109.216L107.484 29.7549H104.875L112.749 13.1074L120.243 29.7549H117.634L115.974 25.9586ZM115.002 23.6948L112.654 18.3657L110.211 23.6948H115.002Z",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M140.214 16.2902V29.7544H137.795V16.2902H134.167V14.0264H143.843V16.2902H140.214Z",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M169.219 16.2908H162.911V20.2761H169.03V22.5399H162.911V27.4916H169.219V29.7554H160.492V14.0273H169.219V16.2908Z",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M194.24 25.9586H187.482L185.75 29.7549H183.142L191.015 13.1074L198.509 29.7549H195.9L194.24 25.9586ZM193.268 23.6948L190.92 18.3657L188.477 23.6948H193.268Z",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M213.831 14.0273V23.5067C213.831 24.3556 213.855 25.3932 214.329 26.2182C214.804 27.02 215.871 27.845 217.27 27.845C218.669 27.845 219.737 27.0197 220.211 26.2182C220.685 25.3929 220.709 24.3553 220.709 23.5067V14.0273H223.128V24.1431C223.128 25.3929 222.867 26.9021 221.658 28.2223C220.828 29.1184 219.429 30.0617 217.27 30.0617C215.112 30.0617 213.713 29.1184 212.883 28.2223C211.673 26.9018 211.413 25.3929 211.413 24.1431V14.0273H213.831Z",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M175.453 36.9502V39.8057C175.763 39.3855 176.23 39.2483 176.652 39.2483C177.178 39.2483 177.652 39.4455 177.989 39.7628C178.359 40.1144 178.593 40.6374 178.593 41.2723C178.593 41.864 178.386 42.4128 177.989 42.8072C177.652 43.1502 177.238 43.3303 176.669 43.3303C175.988 43.3303 175.643 43.013 175.453 42.7383V43.2017H174.211V36.9505H175.453V36.9502ZM175.651 40.5949C175.504 40.7492 175.375 40.9719 175.375 41.298C175.375 41.615 175.513 41.8468 175.66 41.9837C175.859 42.1724 176.134 42.267 176.367 42.267C176.583 42.267 176.824 42.1813 177.014 42.0012C177.195 41.8294 177.316 41.581 177.316 41.298C177.316 40.989 177.195 40.7406 177.014 40.5688C176.816 40.3805 176.6 40.3116 176.35 40.3116C176.083 40.3116 175.85 40.3888 175.651 40.5949Z",
  fill: "black"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M183.154 42.7126L181.317 39.377H182.749L183.835 41.4521L184.896 39.377H186.293L183.197 45.1651H181.8L183.154 42.7126Z",
  fill: "black"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M194.409 43.202L195.331 37.4824H196.435L197.867 40.9039L199.298 37.4824H200.402L201.325 43.202H199.997L199.54 39.7888L198.1 43.202H197.634L196.193 39.7888L195.737 43.202H194.409Z",
  fill: "black"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M207.095 37.4824V42.0869H208.88V43.2019H205.767V37.4824H207.095Z",
  fill: "black"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M214.78 37.4824V43.2019H213.452V37.4824H214.78Z",
  fill: "black"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M221.876 38.5972V43.202H220.548V38.5972H219.297V37.4824H223.127V38.5972H221.876Z",
  fill: "black"
});

function SvgMenuLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 49,
    viewBox: "0 0 224 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLogoMobile);
export default __webpack_public_path__ + "static/media/menu_logo_mobile.e9b4cccb.svg";
export { ForwardRef as ReactComponent };